import { render, staticRenderFns } from "./BigEvent.vue?vue&type=template&id=0aec583c&"
import script from "./BigEvent.vue?vue&type=script&lang=ts&"
export * from "./BigEvent.vue?vue&type=script&lang=ts&"
import style0 from "./BigEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports